import React, { useState } from 'react';
import { energyApi } from '../../services/endpoints';
import { useApiData, StateBlock } from './useApiData';

const PERIODS = ['today', 'week', 'month', 'year'];

export default function Energy() {
  const [period, setPeriod] = useState('week');
  const { data, loading, error, reload } = useApiData(() => energyApi.getSummary(period), [period]);

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Energy</h1>
        <div className="flex gap-1 glass rounded-lg p-1">
          {PERIODS.map((p) => (
            <button
              key={p}
              onClick={() => setPeriod(p)}
              className={`text-xs px-3 py-1.5 rounded-md capitalize ${period === p ? 'bg-[#00d4ff]/20 text-[#00d4ff]' : 'text-white/50'}`}
            >
              {p}
            </button>
          ))}
        </div>
      </div>
      <StateBlock loading={loading} error={error} onRetry={reload}>
        {data && (
          <>
            <div className="grid grid-cols-2 gap-4 mb-6">
              <div className="glass rounded-xl p-5">
                <p className="text-white/50 text-sm">Total usage</p>
                <p className="text-3xl font-bold mt-1">{data.total_kwh} kWh</p>
              </div>
              <div className="glass rounded-xl p-5">
                <p className="text-white/50 text-sm">Estimated cost</p>
                <p className="text-3xl font-bold mt-1">{data.currency} {data.estimated_cost}</p>
              </div>
            </div>
            {data.top_consumers?.length > 0 && (
              <>
                <h2 className="text-lg font-semibold mb-3">Top consumers</h2>
                <div className="space-y-2">
                  {data.top_consumers.map((c, i) => (
                    <div key={i} className="glass rounded-lg px-4 py-3 flex items-center justify-between text-sm">
                      <span>{c.name}</span>
                      <span className="text-white/50">{c.kwh} kWh</span>
                    </div>
                  ))}
                </div>
              </>
            )}
            {data.disclaimer && <p className="text-white/30 text-xs mt-6">{data.disclaimer}</p>}
          </>
        )}
      </StateBlock>
    </div>
  );
}
